const PRIOR_COMPARISON_DISABLED_DATE = '12/31/9999';

const defaultAppliedFilterValues = Object.freeze({
  dateBasis: 'paid',
  timeWindow: 'R12',
  currentPeriodFrom: '',
  currentPeriodTo: '',
  priorPeriodFrom: '',
  priorPeriodTo: '',
  enablePriorComparison: true,
  personIdValue: '',
  populationMode: null,
  cohortLuid: '',
  cohortName: '',
});

export { defaultAppliedFilterValues, PRIOR_COMPARISON_DISABLED_DATE };
